export const QUICKSEARCH_SOURCE = {
  FM: 'FM',
  FM_DIR: 'FM_DIR',
  IL: 'IL'
}

export const MIN_CHAR_COUNT_FOR_SEARCH = 2
